module.exports = __webpack_public_path__ + "toGroom-we-y-n.49b29782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-y-n.jpg
// module id = 7n1/
// module chunks = 0